import { Controller } from '@hotwired/stimulus'
import { format } from 'date-fns'

export default class extends Controller {
  static outlets = [
    'kaia--tabs-component',
    'kaia--date-range-picker-component',
    'kaia--manual-forecast--table-component'
  ]
  static values = { url: String }

  DATE_FORMAT = 'yyyy-MM-dd'

  kaiaManualForecastTableComponentOutletConnected() {
    // enable 15min/1hour toggle when table is loaded
    this.kaiaTabsComponentOutlet.disabledValue = false
  }

  kaiaDateRangePickerComponentOutletConnected(outlet) {
    outlet.onStartDateClick = () => this.handleStartDateChange()
    outlet.onEndDateClick = () => this.handleEndDateChange()
  }

  handleStartDateChange() {
    if (!this.#exceeds7Days(this.selectedStartDate, this.selectedEndDate))
      return

    const rangeEnd = this.selectedStartDate
    rangeEnd.setDate(rangeEnd.getDate() + 6)
    this.kaiaDateRangePickerComponentOutlet.setDates(
      this.selectedStartDate,
      rangeEnd
    )
  }

  handleEndDateChange() {
    if (!this.#exceeds7Days(this.selectedStartDate, this.selectedEndDate))
      return

    const rangeStart = this.selectedEndDate
    rangeStart.setDate(rangeStart.getDate() - 6)
    this.kaiaDateRangePickerComponentOutlet.setDates(
      rangeStart,
      this.selectedEndDate
    )
  }

  showQuarterly() {
    this.tableOutlet.showAllQuarters()
  }

  showHourly() {
    this.tableOutlet.hideAllQuarters()
  }

  changeDateRange() {
    if (!this.selectedStartDate || !this.selectedEndDate) return

    const startDate = format(this.selectedStartDate, this.DATE_FORMAT)
    const endDate = format(this.selectedEndDate, this.DATE_FORMAT)
    window.location.href = `${this.urlValue}?start_date=${startDate}&end_date=${endDate}`
  }

  #exceeds7Days(rangeStart, rangeEnd) {
    return this.#daysInBetween(rangeStart, rangeEnd) > 6
  }

  // From https://stackoverflow.com/a/2627493
  #daysInBetween(startDate, endDate) {
    const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
    return Math.round(Math.abs((startDate - endDate) / oneDay))
  }

  get selectedStartDate() {
    return this.kaiaDateRangePickerComponentOutlet.selectedDates[0]
  }
  get selectedEndDate() {
    return this.kaiaDateRangePickerComponentOutlet.selectedDates[1]
  }

  // shorter, more readable alias
  get tableOutlet() {
    return this.kaiaManualForecastTableComponentOutlet
  }
}
